export const bonuses = [
  {
    number: 1,
    title: 'The Torque Planning Checklist™',
    subtitle: 'A Structured Review Before Finalizing Your Mechanics',
    text: 'A practical checklist covering the essential factors to consider when evaluating a torque-control plan.',
    items: ['Movement objectives.', 'Biomechanical considerations.', 'Anchorage requirements.', 'Anatomical limitations.', 'Monitoring considerations.'],
    value: 37,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2f047678-c82d-4b00-8ec1-8bd690677b9b.jpg',
  },
  {
    number: 2,
    title: 'The Root Movement Visual Atlas™',
    subtitle: 'Understand Complex Movements Through Clear Clinical Illustrations',
    text: 'A visual reference comparing different orthodontic movement patterns.',
    items: ['Controlled tipping.', 'Uncontrolled tipping.', 'Root torque.', 'Bodily movement.', 'Force-system illustrations.'],
    value: 29,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/acabcc0d-51be-4350-8bbc-a1ac0a0d6fd9.jpg',
  },
  {
    number: 3,
    title: 'The Attachment & Power Ridge Decision Guide™',
    subtitle: 'Understand When Different Mechanical Features May Be Considered',
    text: 'A practical educational guide to evaluating attachment designs and aligner features.',
    items: ['Attachment considerations.', 'Power ridge applications.', 'Relevant biomechanical limitations.', 'Alternative mechanics.', 'Clinical decision questions.'],
    value: 27,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cf0b4e12-db30-43a7-8849-d8f2722a3dda.jpg',
  },
  {
    number: 4,
    title: 'The Torque Tracking Assessment Workbook™',
    subtitle: 'A Practical Tool for Reviewing Movement Progress',
    text: 'A structured workbook for documenting torque-related treatment observations.',
    items: ['Baseline movement objectives.', 'Clinical monitoring notes.', 'Planned-versus-observed comparisons.', 'Potential warning signs.', 'Reassessment documentation.'],
    value: 24,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2ec4d2c3-cfda-40b7-95ef-16f6098bcdfc.jpg',
  },
  {
    number: 5,
    title: 'The Orthodontic Torque Case Review Workbook™',
    subtitle: 'Practice Clinical Reasoning With Structured Case Exercises',
    text: 'An educational workbook designed to help you apply the concepts covered throughout the six volumes.',
    items: ['Clinical case scenarios.', 'Guided biomechanical questions.', 'Movement-analysis exercises.', 'Decision-making worksheets.', 'Treatment-planning review templates.'],
    value: 37,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f86b4661-3e7c-48fa-895d-a4cb35d76d6b.jpg',
  },
];
